import React from 'react';
import AssinaturaManager from '../components/AssinaturaManager/AssinaturaManager.jsx';

export default function Assinaturas() {
  return <AssinaturaManager />;
}
